import { BaseRoles } from "@shared/Roles";
import { canViewAllManagersMatchStats } from "./statistics-config";

function isSuperAdmin(roles: readonly string[] | null | undefined): boolean {
  return (
    !!roles?.includes(BaseRoles.SuperAdmin) ||
    !!roles?.includes(BaseRoles.SuperDuperAdmin)
  );
}

/** The two super admins who may assign and delete background images. */
export function canManageBackgroundImages(
  phoneNumber: string | null | undefined,
  roles: readonly string[] | null | undefined,
): boolean {
  return isSuperAdmin(roles) && canViewAllManagersMatchStats(phoneNumber);
}
